export { EvaluationPage as default } from '@/components/enpages/Ir/Evaluation'
